import { utc } from '@date-fns/utc';
import { useMemo } from 'react';

import { usePreferredTimeZone } from '@/api/userAccount';

export const useTzContext = () => {
    const isUtc = usePreferredTimeZone() === 'UTC';
    return useMemo(() => ({ in: isUtc ? utc : undefined }), [isUtc]);
};
